<template>
	<div style="float: right; padding: 13px;">
		<button class="button is-small is-info extra" @click="create">
			<span class="icon"><i class="fas fa-plus"/></span>
			<span>Skapa API-Nyckel</span>
		</button>
	</div>
</template>
<script>
export default {
	data() {
		return {};
	},
	mutation: {},
	methods: {
		create() {
			this.$emit('create');
		}
	}
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";

.panel.info-panel {
  position: absolute;
  pointer-events: none;
  margin-left: -8px;
  top: $navbar-height + 0.75rem;
  background-color: transparent;
  width: calc(100% - 300px);
  color: $white;
  border-radius: 0;
  z-index: 1;

  &.mobile {
    z-index: 4;
    position: fixed;
  }
}

.panel.info-panel.narrow {
  width: 100%;
}

.info-panel .column {
  max-width: 172px;
  padding: 0;
}

.block .label {
  margin-bottom: 2px;
  margin-left: -5px;
  font-size: 10px;
  z-index: 10;
}

.panel-block {
  position: relative;
  padding-top: 17px;
  width: 100%;
  float: right;

  .button {
    z-index: 2;
  }
}

.panel-block:only-child {
  margin-top: 0;
}

.panel-block .box {
  background-color: #f5f5f5;
  color: $dark;
  font-size: 12px;
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #acacac;
  box-shadow: none;
}

.panel.info-panel.mobile {
  margin-top: -12px;
  margin-left: -8px;
}

.panel-block.mobile {
  margin-left: auto;
  margin-right: 0.3rem;
  width: 53px;
  background: #ffffffe5;
  box-shadow: -5px 5px 10px #ffffffe5;
  pointer-events: all;
}
</style>
